/**
 * Catálogo seed — referências realistas do mercado brasileiro de colchões.
 * Valores de densidade e faixas de espessura baseados em práticas comuns
 * da indústria (ABNT NBR 13579-1 como referência qualitativa).
 */
export const MATERIAL_CATALOG_SEED = [
    // ─────────── NÚCLEOS / SUPORTE ───────────
    {
        id: 'mat-d33-core',
        nome: 'Espuma D33 — Núcleo Firme',
        categoria: 'core',
        subtipo: 'polyurethane-d33',
        descricaoTecnica: 'Espuma de poliuretano densidade 33 kg/m³. Núcleo de sustentação de uso comum, boa relação custo-benefício.',
        descricaoComercial: 'Base firme e durável, ideal para biotipo médio e quem busca suporte consistente.',
        densidade: 33,
        firmeza: 'firm',
        elasticidade: 'medium',
        ventilacao: 'medium',
        usoRecomendado: ['núcleo', 'linha intermediária'],
        alturaMinMm: 80,
        alturaMaxMm: 200,
        unidadePadraoMm: 10,
        alturaDefaultMm: 130,
        appearance: {
            baseColor: '#d2b889',
            roughness: 0.92,
            translucency: 0.02,
            sheen: 0.0,
            grainIntensity: 0.55,
        },
        tags: ['núcleo', 'firme', 'poliuretano'],
    },
    {
        id: 'mat-d45-core',
        nome: 'Espuma D45 — Núcleo Alta Densidade',
        categoria: 'core',
        subtipo: 'polyurethane-d45',
        descricaoTecnica: 'Poliuretano densidade 45 kg/m³. Núcleo para biotipos acima de 90 kg, maior durabilidade e menor deformação permanente.',
        descricaoComercial: 'Suporte reforçado para quem precisa de firmeza extra e longevidade do colchão.',
        densidade: 45,
        firmeza: 'extra-firm',
        elasticidade: 'medium',
        ventilacao: 'low',
        usoRecomendado: ['núcleo premium', 'biotipo pesado'],
        alturaMinMm: 100,
        alturaMaxMm: 220,
        unidadePadraoMm: 10,
        alturaDefaultMm: 160,
        appearance: {
            baseColor: '#c8a973',
            roughness: 0.9,
            translucency: 0.01,
            sheen: 0.0,
            grainIntensity: 0.6,
        },
        tags: ['núcleo', 'extra-firme', 'poliuretano', 'premium'],
    },
    {
        id: 'mat-hr-core',
        nome: 'Espuma HR — Alta Resiliência',
        categoria: 'core',
        subtipo: 'hr-foam',
        descricaoTecnica: 'High Resilience foam, célula aberta, densidade ~35-40 kg/m³. Retorno rápido, ótima ventilação.',
        descricaoComercial: 'Conforto ativo: responde ao corpo sem afundar, mantém o alinhamento postural.',
        densidade: 38,
        firmeza: 'medium-firm',
        elasticidade: 'high',
        ventilacao: 'high',
        usoRecomendado: ['núcleo premium', 'linha ortopédica'],
        alturaMinMm: 80,
        alturaMaxMm: 200,
        unidadePadraoMm: 10,
        alturaDefaultMm: 140,
        appearance: {
            baseColor: '#b9c49a',
            roughness: 0.88,
            translucency: 0.04,
            sheen: 0.02,
            grainIntensity: 0.5,
        },
        tags: ['núcleo', 'alta-resiliência', 'ventilado'],
    },
    {
        id: 'mat-pocket-coil',
        nome: 'Molas Ensacadas',
        categoria: 'core',
        subtipo: 'pocket-coil',
        descricaoTecnica: 'Molas independentes ensacadas individualmente, isolam movimentos e oferecem suporte por pontos.',
        descricaoComercial: 'Tecnologia híbrida: suporte ponto a ponto e menor transmissão de movimento — ideal para casais.',
        firmeza: 'medium-firm',
        elasticidade: 'very-high',
        ventilacao: 'very-high',
        usoRecomendado: ['núcleo híbrido', 'casais', 'colchão premium'],
        alturaMinMm: 120,
        alturaMaxMm: 240,
        unidadePadraoMm: 10,
        alturaDefaultMm: 180,
        appearance: {
            baseColor: '#bfb9a8',
            roughness: 0.75,
            translucency: 0.0,
            sheen: 0.05,
            grainIntensity: 0.2,
        },
        tags: ['núcleo', 'molas', 'ensacada', 'premium'],
    },
    // ─────────── TRANSIÇÃO ───────────
    {
        id: 'mat-transition-d28',
        nome: 'Espuma D28 — Camada de Transição',
        categoria: 'transition',
        subtipo: 'transition-layer',
        descricaoTecnica: 'Poliuretano D28 em lâmina, usado como camada de transição entre núcleo firme e conforto macio.',
        descricaoComercial: 'Alinha o conforto: amortece o contato com o núcleo e distribui o peso.',
        densidade: 28,
        firmeza: 'medium',
        elasticidade: 'medium',
        ventilacao: 'medium',
        usoRecomendado: ['transição'],
        alturaMinMm: 10,
        alturaMaxMm: 50,
        unidadePadraoMm: 5,
        alturaDefaultMm: 25,
        appearance: {
            baseColor: '#dcc691',
            roughness: 0.92,
            translucency: 0.03,
            sheen: 0.0,
            grainIntensity: 0.5,
        },
        tags: ['transição', 'poliuretano'],
    },
    {
        id: 'mat-transition-hr',
        nome: 'HR Fino — Transição Resiliente',
        categoria: 'transition',
        subtipo: 'hr-foam',
        descricaoTecnica: 'Lâmina de espuma HR de transição, célula aberta — retorno progressivo e ventilação intermediária.',
        descricaoComercial: 'Transição dinâmica que acrescenta conforto ativo sem abrir mão do suporte.',
        densidade: 35,
        firmeza: 'medium',
        elasticidade: 'high',
        ventilacao: 'high',
        usoRecomendado: ['transição premium'],
        alturaMinMm: 15,
        alturaMaxMm: 60,
        unidadePadraoMm: 5,
        alturaDefaultMm: 30,
        appearance: {
            baseColor: '#c4cfa2',
            roughness: 0.88,
            translucency: 0.04,
            sheen: 0.02,
            grainIntensity: 0.5,
        },
        tags: ['transição', 'alta-resiliência'],
    },
    // ─────────── CONFORTO ───────────
    {
        id: 'mat-soft-d23',
        nome: 'Espuma D23 — Conforto Macio',
        categoria: 'comfort',
        subtipo: 'soft-comfort',
        descricaoTecnica: 'Poliuretano D23 em lâmina fina, acolchoamento macio sob o tecido superior.',
        descricaoComercial: 'Toque macio que acolhe o corpo nos primeiros centímetros.',
        densidade: 23,
        firmeza: 'soft',
        elasticidade: 'medium',
        ventilacao: 'medium',
        usoRecomendado: ['conforto', 'acolchoamento'],
        alturaMinMm: 10,
        alturaMaxMm: 50,
        unidadePadraoMm: 5,
        alturaDefaultMm: 20,
        appearance: {
            baseColor: '#e7d3a0',
            roughness: 0.95,
            translucency: 0.05,
            sheen: 0.0,
            grainIntensity: 0.6,
        },
        tags: ['conforto', 'macio', 'poliuretano'],
    },
    {
        id: 'mat-memory-50',
        nome: 'Memory Foam D50 — Viscoelástico',
        categoria: 'specialty',
        subtipo: 'memory-foam',
        descricaoTecnica: 'Espuma viscoelástica 50 kg/m³. Resposta lenta, molda-se ao corpo, alivia pontos de pressão.',
        descricaoComercial: 'Abraço térmico: molda-se ao seu corpo e alivia ombros e quadril.',
        densidade: 50,
        firmeza: 'medium-soft',
        elasticidade: 'low',
        ventilacao: 'medium',
        usoRecomendado: ['conforto superior', 'alívio de pressão'],
        alturaMinMm: 15,
        alturaMaxMm: 70,
        unidadePadraoMm: 5,
        alturaDefaultMm: 30,
        appearance: {
            baseColor: '#a08a6b',
            roughness: 0.82,
            translucency: 0.12,
            sheen: 0.02,
            grainIntensity: 0.35,
        },
        tags: ['memory', 'viscoelástico', 'premium'],
    },
    {
        id: 'mat-memory-65',
        nome: 'Memory Foam D65 — Alta Densidade',
        categoria: 'specialty',
        subtipo: 'memory-foam',
        descricaoTecnica: 'Viscoelástico 65 kg/m³, maior durabilidade, resposta térmica controlada.',
        descricaoComercial: 'Conforto terapêutico de longa duração para quem valoriza alívio profundo.',
        densidade: 65,
        firmeza: 'medium-soft',
        elasticidade: 'low',
        ventilacao: 'medium',
        usoRecomendado: ['conforto premium', 'terapêutico'],
        alturaMinMm: 20,
        alturaMaxMm: 80,
        unidadePadraoMm: 5,
        alturaDefaultMm: 40,
        appearance: {
            baseColor: '#8f7a5d',
            roughness: 0.8,
            translucency: 0.14,
            sheen: 0.03,
            grainIntensity: 0.3,
        },
        tags: ['memory', 'viscoelástico', 'alta-densidade', 'premium'],
    },
    {
        id: 'mat-latex-natural',
        nome: 'Látex Natural',
        categoria: 'specialty',
        subtipo: 'latex-natural',
        descricaoTecnica: 'Látex natural, ~85 kg/m³, com microperfurações para ventilação. Retorno rápido e hipoalergênico.',
        descricaoComercial: 'Conforto elástico e fresco — acolhe sem abraçar, boa opção para peles sensíveis.',
        densidade: 85,
        firmeza: 'medium',
        elasticidade: 'very-high',
        ventilacao: 'very-high',
        usoRecomendado: ['conforto premium', 'hipoalergênico'],
        alturaMinMm: 20,
        alturaMaxMm: 100,
        unidadePadraoMm: 5,
        alturaDefaultMm: 50,
        appearance: {
            baseColor: '#e3c7a3',
            roughness: 0.62,
            translucency: 0.18,
            sheen: 0.25,
            grainIntensity: 0.15,
        },
        tags: ['látex', 'natural', 'ventilado', 'premium'],
    },
    {
        id: 'mat-latex-synth',
        nome: 'Látex Sintético',
        categoria: 'specialty',
        subtipo: 'latex-synthetic',
        descricaoTecnica: 'Látex sintético (SBR), ~75 kg/m³. Alternativa acessível ao natural, com excelente resiliência.',
        descricaoComercial: 'Alto retorno elástico com excelente custo-benefício.',
        densidade: 75,
        firmeza: 'medium',
        elasticidade: 'very-high',
        ventilacao: 'high',
        usoRecomendado: ['conforto premium'],
        alturaMinMm: 20,
        alturaMaxMm: 100,
        unidadePadraoMm: 5,
        alturaDefaultMm: 40,
        appearance: {
            baseColor: '#d8bf9b',
            roughness: 0.65,
            translucency: 0.15,
            sheen: 0.2,
            grainIntensity: 0.18,
        },
        tags: ['látex', 'sintético', 'ventilado'],
    },
];
// ────────────────────────────────────────────────
// Tecidos
// ────────────────────────────────────────────────
export const FABRIC_CATALOG_SEED = [
    {
        id: 'fab-knit-soft',
        nome: 'Malha Stretch Premium',
        tipoTecido: 'knit',
        composicao: '76% poliéster, 20% viscose, 4% elastano',
        uso: 'top-and-side',
        descricao: 'Malha macia e elástica, toque acolhedor. Absorve suavemente o formato do quilting.',
        corBase: '#efe7d4',
        textureSet: 'fabric-knit',
        stretchVisual: 'medium',
        brilho: 0.12,
        quiltPattern: 'diamond',
        tags: ['tecido', 'malha', 'macio', 'premium'],
    },
    {
        id: 'fab-jacquard',
        nome: 'Jacquard Clássico',
        tipoTecido: 'jacquard',
        composicao: '100% poliéster fiado',
        uso: 'top',
        descricao: 'Tecido encorpado com padrão tramado. Visual clássico, adequado para tampos com quilting estruturado.',
        corBase: '#ece3cf',
        textureSet: 'fabric-jacquard',
        stretchVisual: 'subtle',
        brilho: 0.18,
        quiltPattern: 'square',
        tags: ['tecido', 'jacquard', 'clássico'],
    },
    {
        id: 'fab-plain-premium',
        nome: 'Tecido Plano Premium',
        tipoTecido: 'plain-premium',
        composicao: 'poliéster premium com acabamento fosco',
        uso: 'top',
        descricao: 'Tecido plano de toque seco, baixo brilho, ideal para visual moderno e minimalista.',
        corBase: '#e4dcc5',
        textureSet: 'fabric-plain',
        stretchVisual: 'none',
        brilho: 0.08,
        quiltPattern: 'lines',
        tags: ['tecido', 'plano', 'moderno'],
    },
    {
        id: 'fab-suede-side',
        nome: 'Suede Estofado — Lateral',
        tipoTecido: 'suede',
        composicao: 'suede de poliéster escovado',
        uso: 'side',
        descricao: 'Acabamento lateral aveludado, tom terroso discreto, ideal para faixas acolchoadas.',
        corBase: '#8a7a58',
        textureSet: 'fabric-suede',
        stretchVisual: 'subtle',
        brilho: 0.15,
        quiltPattern: 'none',
        tags: ['tecido', 'suede', 'lateral'],
    },
    {
        id: 'fab-quilted-top',
        nome: 'Tampo Quiltado Estruturado',
        tipoTecido: 'quilted',
        composicao: 'malha + manta acrílica + costura quiltada',
        uso: 'top',
        descricao: 'Tampo com quilting estruturado em diamante, acabamento premium com sensação de estofado.',
        corBase: '#f0e8d3',
        textureSet: 'fabric-quilted',
        stretchVisual: 'medium',
        brilho: 0.14,
        quiltPattern: 'diamond',
        tags: ['tecido', 'quiltado', 'estofado', 'premium'],
    },
];
